var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone-solid-rounded 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0022 15.6071C8.46492 14.1969 6.3094 12.0414 4.89918 9.50411C4.32005 8.46215 4.01942 7.58098 3.83039 6.69129C3.49348 5.10519 4.21353 3.60577 5.35421 2.68044C5.68891 2.40891 6.10359 2.28614 6.51865 2.37634C6.92681 2.46507 7.24728 2.74028 7.44593 3.09181C7.48938 3.16865 7.5333 3.24607 7.57751 3.32402C7.72863 3.59046 7.88308 3.86274 8.03152 4.13639C8.32624 4.67967 8.51359 5.19003 8.44852 5.73978C8.38524 6.27447 8.09423 6.73313 7.73989 7.19881L6.61958 8.67106C6.51969 8.80235 6.46975 8.868 6.46679 8.946C6.46383 9.024 6.5077 9.09171 6.59548 9.22719C7.80201 11.0893 9.41695 12.7042 11.2791 13.9108C11.4145 13.9985 11.4823 14.0424 11.5603 14.0395C11.6383 14.0365 11.7039 13.9866 11.8352 13.8867L13.3075 12.7664C13.7731 12.412 14.2318 12.121 14.7665 12.0577C15.3162 11.9927 15.8266 12.18 16.3699 12.4747C16.6435 12.6232 16.9158 12.7776 17.1822 12.9287L17.1831 12.9293C17.2608 12.9733 17.3379 13.0171 17.4144 13.0603C17.766 13.259 18.0412 13.5795 18.1299 13.9876C18.2201 14.4027 18.0974 14.8174 17.8259 15.1521C16.9005 16.2927 15.4011 17.0128 13.8149 16.6758C12.9253 16.4869 12.0441 16.1862 11.0022 15.6071Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.71cd689a401862111249c53bb4dd9199.svg";
export { ForwardRef as ReactComponent };